import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import LogisticRouteTagsApi from '@/services/apiServiceModules/logisticRouteTagsApi.js'
const logisticRouteTagsApi = new LogisticRouteTagsApi()

export default class LogisticRouteTagsDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.LOGISTIC_ROUTE_TAGS, logisticRouteTagsApi, {
			useCache: true,
		})
	}
}
